import { HeroSection } from './components/HeroSection';
import { SeriesSection } from './components/SeriesSection';
import { FeaturedProducts } from './components/FeaturedProducts';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BlogPreview } from './components/BlogPreview';
import { CTASection } from './components/CTASection';
import { InstagramSection } from './components/InstagramSection';
import { TikTokSection } from './components/TikTokSection';
import { SocialSidebar } from '../../components/feature/SocialSidebar';
import { useSEO } from '@/hooks/useSEO';

const HomePage = () => {
  useSEO({
    title: 'ZpiritualZ Den Haag | Spirituele Webshop – Blue Protect & Evil Energy Destroy',
    description: 'ZpiritualZ in Den Haag – Premium spirituele beschermingsproducten. Blue Protect Serie (indigofera) & Evil Energy Destroy Serie (hing) voor bescherming tegen het boze oog & negatieve energie. Snel geleverd in NL & BE.',
    canonical: 'https://www.zpiritualz.com/',
    keywords: 'spirituele webshop Den Haag, boze oog bescherming, evil energy destroy, blue protect, hing asafoetida, spirituele producten Nederland',
    ogImage: 'https://public.readdy.ai/ai/img_res/23bcd022e650043adaeffd8064b1b654.jpg',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'ZpiritualZ',
      url: 'https://www.zpiritualz.com',
      description: 'Premium spirituele beschermingsproducten gebaseerd op eeuwenoude tradities. Blue Protect Serie en Evil Energy Destroy Serie.',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.zpiritualz.com/shop?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      publisher: {
        '@type': 'Organization',
        name: 'ZpiritualZ',
        url: 'https://www.zpiritualz.com',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.zpiritualz.com/logo.png',
        },
      },
    },
  });

  return (
    <main className="bg-[#050010]">
      <SocialSidebar />
      <HeroSection />
      <SeriesSection />
      <FeaturedProducts />
      <TestimonialsSection />
      <BlogPreview />
      <InstagramSection />
      <TikTokSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
